export default [{
    path: '/add-new-capture',
    name: 'add-new-capture',
    component: () =>
        import ('@/views/add-new-capture/AddNewCapture.vue'),
    meta: {
        pageTitle: 'Add New Capture',
    },
}]